import LegalPage from "../components/LegalPage";

const SECTIONS = [
    {
        heading: "Acceptance of these terms",
        body: [
            "These Terms & Conditions govern your use of the sahikhoj.com website and the SahiKhoj mobile application. By using the website or the app, you agree to these terms. If you do not agree, please do not use them.",
        ],
    },
    {
        heading: "About this website",
        body: [
            "The sahikhoj.com website is an informational website only. It describes the SahiKhoj mobile application and provides company, contact and legal information.",
            "The website does not offer product search, price comparison, coupon redemption, travel booking, accounts, payments or any transaction functionality.",
        ],
    },
    {
        heading: "About the SahiKhoj app",
        body: [
            "SahiKhoj is a discovery and comparison app. It helps users explore prices, deals, coupons and travel options across supported third-party platforms.",
            "SahiKhoj is not a seller, merchant, airline, hotel or travel agent, and does not process orders, payments or bookings.",
        ],
    },
    {
        heading: "Third-party platforms",
        body: [
            "Products, prices, offers, coupons, flights and hotels shown in the app relate to third-party platforms and merchants. Your purchase or booking is made on the respective third-party platform and is subject to that platform's own terms, conditions and policies.",
            "SahiKhoj is not responsible for the products, services, pricing, delivery, refunds or conduct of third-party platforms.",
        ],
    },
    {
        heading: "Product information and prices",
        body: [
            "Product information and prices displayed in the app are sourced from supported platforms and may change at any time without notice. The final price, availability and applicable charges are always those shown on the third-party platform at the time of purchase.",
        ],
    },
    {
        heading: "Coupons, deals and offers",
        body: [
            "Coupons, deals and offers are provided by third-party merchants and may be modified, withdrawn or expired at any time. SahiKhoj does not guarantee that any coupon or offer will be valid, applicable or honoured.",
        ],
    },
    {
        heading: "Travel information",
        body: [
            "Flight, hotel and other travel information surfaced in the app is provided by third parties. Schedules, fares, availability and policies may change. Always confirm the final details on the respective travel provider's platform before booking.",
        ],
    },
    {
        heading: "External links",
        body: [
            "The website or app may contain links to external websites or platforms. We do not control and are not responsible for the content, accuracy or practices of external sites.",
        ],
    },
    {
        heading: "Accuracy and availability",
        body: [
            "We work to keep information accurate and the website and app available, but we do not warrant that content will always be complete, current or error-free, or that the service will be uninterrupted.",
        ],
    },
    {
        heading: "Your responsibilities",
        body: [
            "You agree to use the website and app lawfully and fairly; to verify prices, availability and terms on the respective third-party platform before completing any transaction; and not to misuse, scrape, disrupt or attempt to gain unauthorised access to the service.",
        ],
    },
    {
        heading: "Intellectual property",
        body: [
            "The SahiKhoj name, logo, design and content of this website are the property of SahiKhoj. Third-party trademarks, logos and brand names referenced belong to their respective owners, and their use does not imply endorsement or affiliation.",
        ],
    },
    {
        heading: "Changes to the service",
        body: [
            "We may add, modify or discontinue features of the website or app at any time. We may also update these terms; the “Last updated” date reflects the most recent revision, and continued use after an update constitutes acceptance.",
        ],
    },
    {
        heading: "Limitation of liability",
        body: [
            "To the maximum extent permitted by law, SahiKhoj is not liable for any indirect, incidental or consequential loss arising from your use of the website or app, or from transactions you make on third-party platforms.",
            "The website and app are provided on an “as is” and “as available” basis, without warranties of any kind.",
        ],
    },
    {
        heading: "Governing law",
        body: [
            "These terms are governed by the laws of India, without regard to conflict of law principles.",
        ],
    },
];

const TermsPage = () => (
    <LegalPage
        title="Terms & Conditions"
        eyebrow="SahiKhoj Legal"
        updated="July 2026"
        description="The terms that govern use of the SahiKhoj website and the SahiKhoj mobile application."
        path="/terms-and-conditions"
        intro="The ground rules for using the SahiKhoj website and mobile app — kept as clear as we can make them."
        sections={SECTIONS}
        testId="terms-page"
    />
);

export default TermsPage;
